import { render, staticRenderFns } from "./AuctionHouse.vue?vue&type=template&id=1a167cf4&"
import script from "./AuctionHouse.vue?vue&type=script&lang=js&"
export * from "./AuctionHouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports